module.exports = __webpack_public_path__ + "img/checkbox.5ccba86e.svg";